import { PROTECTION_SERVICES_EXPERIAN_FORM } from '../constants';

export const getProtectionServicesExperianDetails = (payload, routeProps, submitPrivacyRequestPayload) => ({
    type: PROTECTION_SERVICES_EXPERIAN_FORM.GET_PROTECTION_SERVICES_EXPERIAN_DETAILS,
    payload: {
        payload,
        routeProps,
        submitPrivacyRequestPayload
    }
})

export const verifyProtectionServicesExperianDetails = (payload, routeProps, historyProps, submitPrivacyRequestPayload) => ({
    type: PROTECTION_SERVICES_EXPERIAN_FORM.VERIFY_PROTECTION_SERVICES_EXPERIAN_DETAILS,
    payload: {
        payload,
        routeProps,
        historyProps,
        submitPrivacyRequestPayload
    }
})

export const getProtectionServicesExperianDetailsCheckMyRequests = (payload, routeProps) => ({
    type: PROTECTION_SERVICES_EXPERIAN_FORM.GET_PROTECTION_SERVICES_EXPERIAN_DETAILS_CHECK_MY_REQUESTS,
    payload: {
        payload,
        routeProps
    }
})

export const verifyProtectionServicesExperianDetailsCheckMyRequests = (payload, historyProps, checkRequestPayload) => ({
    type: PROTECTION_SERVICES_EXPERIAN_FORM.VERIFY_PROTECTION_SERVICES_EXPERIAN_DETAILS_CHECK_MY_REQUESTS,
    payload: {
        payload,
        historyProps,
        checkRequestPayload
    }
})

export const clearProtectionServicesExperianDetails = () => ({
    type: PROTECTION_SERVICES_EXPERIAN_FORM.CLEAR_DETAILS,
    payload: {}
})
